import React from 'react';
import '../App.css';

const Skeleton = ({ 
  type = 'default', 
  width = '100%', 
  height = '20px', 
  count = 1,
  className = '',
  style = {} 
}) => {
  const skeletons = [];

  for (let i = 0; i < count; i++) {
    skeletons.push(
      <div
        key={i}
        className={`skeleton ${type} ${className}`}
        style={{
          width,
          height,
          marginBottom: i < count - 1 ? '10px' : '0',
          ...style
        }}
      />
    );
  }

  return <div className="skeleton-container">{skeletons}</div>;
};

// Skeleton específico para carruseles de auspiciantes - Como en la imagen
export const SkeletonCarousel = () => (
  <div className="skeleton-carousel" style={{ marginTop: '5rem', marginBottom: '2rem' }}>
    <div className="skeleton-carousel-container">
      {[1, 2, 3, 4, 5, 6].map((item) => (
        <div key={item} className="skeleton-carousel-item">
          <Skeleton type="image" width="180px" height="100px" style={{ backgroundColor: 'white', border: '1px solid #ddd' }} />
        </div>
      ))}
    </div>
  </div>
);

// Skeleton para la formación - USA LA MISMA ESTRUCTURA que Formacion1.jsx
export const SkeletonFormacion = () => {
  // Crear array de 15 items skeleton como si fueran productos
  const skeletonItems = Array.from({ length: 15 }, (_, index) => ({
    id_producto: `skeleton-${index + 1}`,
    nombre_producto: `Producto ${index + 1}`,
    imagen_producto: 'skeleton.jpg'
  }));

  return (
    <div>
      <div id="cancha">
        {skeletonItems.map((item) => (
          <div
            key={item.id_producto}
            className={`jugador titular ${item.id_producto}`}
            id={item.id_producto}
          >
            <div className="link-name">
              <div>
                                 <div 
                   className="camiseta"
                   style={{ 
                     width: '70px',
                     height: '70px',
                     borderRadius: '50%',
                     border: '3px solid #ffffff',
                     backgroundColor: '#2c2c2c',
                     display: 'flex',
                     alignItems: 'center',
                     justifyContent: 'center'
                   }}
                 >
                   <div style={{
                     width: '40px',
                     height: '40px',
                     borderRadius: '50%',
                     backgroundColor: '#f0f0f0',
                     opacity: 0.3
                   }} />
                 </div>
                                 <p className="nombreju">
                   <Skeleton 
                     type="text" 
                     width="60px" 
                     height="10px"
                     style={{ 
                       backgroundColor: '#1e3a8a',
                       borderRadius: '1rem',
                       animation: 'none'
                     }}
                   />
                 </p>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

// Skeleton para botones - EXACTO al contenedor real
export const SkeletonButtons = () => (
  <div className="comocalificarf">
    <div className="cfff">
      <Skeleton 
        type="button" 
        className="yellow-button"
        width="13rem" 
        height="4rem" 
        style={{ 
          backgroundColor: '#FDF006',
          borderRadius: '1rem',
          margin: '2rem',
          fontSize: '1.5rem',
          animation: 'none',
          border: 'none'
        }} 
      />
      <Skeleton 
        type="button" 
        className="yellow-button"
        width="13rem" 
        height="4rem" 
        style={{ 
          backgroundColor: '#FDF006',
          borderRadius: '1rem',
          margin: '2rem',
          fontSize: '1.5rem',
          animation: 'none',
          border: 'none'
        }} 
      />
    </div>
  </div>
);

// Skeleton para gráficos
export const SkeletonGraphics = () => (
  <div className="skeleton-graphics">
    <Skeleton type="title" width="250px" height="35px" style={{ margin: '2rem auto' }} />
    <div className="skeleton-chart">
      <Skeleton type="chart" width="100%" height="300px" />
    </div>
  </div>
);

// Skeleton para contacto - Como en la imagen
export const SkeletonContact = () => (
  <div className="skeleton-contact">
    {/* Botón Contactanos como en la imagen */}
    <div className="skeleton-contact-button" style={{ textAlign: 'center', marginBottom: '2rem' }}>
      <Skeleton type="button" width="200px" height="50px" style={{ backgroundColor: '#28a745', borderRadius: '25px' }} />
    </div>
    
    {/* 4 iconos de redes sociales como en la imagen */}
    <div className="skeleton-contact-icons" style={{ display: 'flex', justifyContent: 'center', gap: '30px', marginBottom: '2rem' }}>
      {[1, 2, 3, 4].map((item) => (
        <div 
          key={item} 
          style={{ 
            width: '50px', 
            height: '50px', 
            borderRadius: '50%', 
            backgroundColor: 'white',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          }}
        >
          <div style={{
            width: '30px',
            height: '30px',
            borderRadius: '50%',
            backgroundColor: '#e0e0e0',
            opacity: 0.5
          }} />
        </div>
      ))}
    </div>
    
    {/* Texto "Desarrollado por" */}
    <div className="skeleton-footer-text" style={{ textAlign: 'center' }}>
      <Skeleton type="text" width="150px" height="16px" style={{ margin: '0 auto 10px' }} />
      <Skeleton type="text" width="250px" height="18px" style={{ margin: '0 auto' }} />
    </div>
  </div>
);

export default Skeleton; 